import { createFileRoute, redirect } from '@tanstack/react-router';

// DEC-010: `/library` was renamed to `/sources` to clarify that the page lists
// the user's sources (codebases + PDFs). This redirect keeps old bookmarks,
// telemetry-toast deep links, and the in-app `/$organizationName/library`
// link-targets working — forward search params verbatim so onboarding,
// filter, and pagination params survive.
export const Route = createFileRoute('/$organizationName/library')({
  component: () => null,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/$organizationName/sources',
      params,
      search: search as any,
    });
  },
});
